export * from './HgListingAttachedDocument';
export * from './HgListingVideoMovie';
export * from './HgListingVirtualTour';
export * from './HgLocalStorageKey';
export * from './HgNewConstruction';
export * from './HgSessionStorageKey';
export * from './PriceDropAlertStatus';

export enum ListingDetailsModalTabId {
  MODAL_TAB_ID_IMAGEGALLERY = 'modal-tab-imagegallery',
  MODAL_TAB_ID_FLOOR_PLAN = 'modal-tab-floor-plan',
  MODAL_TAB_ID_VIRTUALTOUR = 'modal-tab-virtualtour',
  MODAL_TAB_ID_VIDEOMOVIE = 'modal-tab-videomovie',
}

export enum GalleryContactCtaVariant {
  COVER = 'cover',
  DETAIL = 'detail',
}
